import * as types from './actionTypes';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  loading: true,
  contributorData: {},
  myDrafts: [],
  myDraftEateries: [],
  loadingDraftEateries: false,
  myDraftEateriesOffset: 0,
  myDraftStories: [],
  loadingDraftStories: false,
  myDraftStoriesOffset: 0,
  myDraftListicles: [],
  loadingDraftListicles: false,
  myDraftListicleOffset: 0,
  myPublishedEateries: [],
  loadingPublishedEateries: false,
  myPublishedEateriesOffset: 0,
  myPublishedStories: [],
  loadingPublishedStories: false,
  myPublishedStoriesOffset: 0,
  myPublishedListicles: [],
  loadingPublishedListicles: false,
  myPublishedListiclesOffset: 0,
  myFollowers: [],
  loadingMyFollowers: false,
  myFollowersOffset: 0,
  iFollow: [],
  loadingIFollow: false,
  iFollowOffset: 0,
  applauses: [],
  loadingApplauses: false,
  applausesOffset: 0,
  deleting: false
});

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.LOADED:
      return {
        ...state,
        loading: false,
        contributorData: action.contributorData,
        myDraftEateries: action.myDraftEateries,
        myDraftStories: action.myDraftStories,
        myDraftListicles: action.myDraftListicles,
        myPublishedEateries: action.myPublishedEateries,
        myPublishedStories: action.myPublishedStories,
        myPublishedListicles: action.myPublishedListicles,
        myFollowers: action.myFollowers,
        iFollow: action.iFollow,
      };
    case types.LOADINGPAGEDATA:
      return {
        ...state,
        [action.flagName]: true
      };
    case types.LOADEDPAGEDATA:
      return {
        ...state,
        [action.listName]: action.pageData,
        [action.offsetName]: action.offset,
        [action.flagName]: false
      };
    case types.DELETING:
      return {
        ...state,
        deleting: true
      };
    case types.DELETED:
      return {
        ...state,
        deleting: false
      };
    default:
      return state;
  }
}

//Selectors
export function getValue(state, key) {
  const value = state['myDashboard'][key];
  switch (key) {
    default:
      return value;
  }
}

export function getAllValues(state, key) {
  return state['myDashboard'];
}
